/* eslint-disable handle-callback-err */
import React from 'react';
import { alert } from './helpers/rsuite/Alerts';
import { cuotitasStoreService } from './services';

export class ErrorBoundary extends React.Component {
    constructor (props) {
        super(props);
        this.state = { hasError: false };
    }

    // Update state so the next render will show the fallback UI.
    static getDerivedStateFromError (error) {
        return { hasError: true };
    }

    // Log the error to an error reporting service
    componentDidCatch (error, errorInfo) {
        cuotitasStoreService.registerLoanLogsError(error, errorInfo);
    }

    componentDidUpdate () {
        if (this.state.hasError) {
            alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, recargue la página para continuar. ', 0, 'topCenter', null, null, 'error-boundry');
        }
    }

    // Render any custom fallback UI
    render () {
        return this.props.children;
    }
}
